<template>
  <v-flex xs12 sm6 d-flex>
    <v-select
      :items="validStatus"
      label="Status"
      v-model="status"
      item-text="title"
      item-value="business"
      return-object
      prepend-icon="label"
    ></v-select>
  </v-flex>
</template>
<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import * as business from "@/helpers/business";

export default {
  name: "Status",
  computed: {
    status: {
      get() {
        return this.model;
      },
      set(newStatus) {
        this.$store.dispatch("partners_payments/setStatus", newStatus);
        this.model;
      },
    },
    ...mapGetters({
      model: "partners_payments/filtersStatus",
    }),
  },
  data: () => ({
    validStatus: [
      { title: "Todos", business: "" },
      { title: "Aguardando", business: business.PAYMENT_STATUS_WAITING },
      { title: "Processando", business: business.PAYMENT_STATUS_PROCESSING },
      { title: "Aprovado", business: business.PAYMENT_STATUS_APPROVED },
      { title: "Cancelado", business: business.PAYMENT_STATUS_CANCELLED },
      { title: "Compensado", business: business.PAYMENT_STATUS_COMPLETED },
      { title: "Estornado", business: business.PAYMENT_STATUS_REFUNDED },
      { title: "Antecipado", business: business.PAYMENT_STATUS_ANTICIPATION },
    ],
  }),
};
</script>
